import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';

import { ContactDto, CreateContactRequest } from '../../../common/PricePrgClient';
import { createAsyncAction } from '../../../utils';

const contactEntity = new schema.Entity<ContactDto>('contacts', undefined, {
    idAttribute: 'contactId'
});

export const fetchContacts = createAsyncAction<void, ContactDto[]>('contacts', 'fetchContacts');
export const createContact = createAsyncAction<CreateContactRequest, ContactDto>('contacts', 'createContact');
export const updateContact = createAsyncAction<ContactDto, ContactDto>('contacts', 'updateContact');
export const deleteContact = createAsyncAction<number, number>('contacts', 'deleteContact');

const contactsSlice = createSlice({
    name: 'contacts',
    initialState: {} as { [contactId: string]: ContactDto },
    reducers: {},
    extraReducers: builder =>
        builder
            .addCase(fetchContacts.success, (state, action) => {
                const normalized = normalize(action.payload, [contactEntity]);
                return normalized.entities.contacts ?? {};
            })
            .addCase(updateContact.success, (state, action) => {
                state[action.payload.contactId] = action.payload;
            })
            .addCase(deleteContact.success, (state, action) => {
                delete state[action.payload];
            })
            .addCase(createContact.success, (state, action) => {
                state[action.payload.contactId] = action.payload;
            })
});

const uiSlice = createSlice({
    name: 'contacts',
    initialState: { showCreateContactDialog: false, isLoading: false },
    reducers: {
        setShowCreateContactDialog: (state, action: PayloadAction<boolean>) => ({
            ...state,
            showCreateContactDialog: action.payload
        })
    },
    extraReducers: builder =>
        builder.addCase(createContact.success, () => ({
            showCreateContactDialog: false,
            isLoading: false
        }))
});
export const { setShowCreateContactDialog } = uiSlice.actions;

export default combineReducers({ contacts: contactsSlice.reducer, ui: uiSlice.reducer });
